<template>
    <nav class="desktop-nav" :class="{ scrolled: scrolled }">
        <div class="nav-left">
            <div class="brand" @click="goTo('/')">
                <h2>QB</h2>
            </div>

            <div class="nav-items">
                <div v-for="(item, i) in sections" :key="i"
                    class="nav-item"
                    :class="{ active: isActive(item.url) }"
                    v-ripple
                    @click="goTo(item.url)"
                >
                    <span class="nav-label">{{ item.label }}</span>
                </div>
            </div>
        </div>

        <div class="nav-right">
            <div class="remote-wrapper" ref="remoteWrapper">
                <div class="nav-item" v-ripple @click="toggleRemote">
                    <div class="nav-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                            <rect x="2" y="6" width="20" height="12" rx="3" stroke="currentColor" stroke-width="1.5"/>
                            <circle cx="8" cy="12" r="1.5" fill="currentColor"/>
                            <circle cx="12" cy="10" r="1" fill="currentColor"/>
                            <circle cx="12" cy="14" r="1" fill="currentColor"/>
                            <circle cx="16" cy="12" r="1.5" fill="currentColor"/>
                        </svg>
                    </div>
                    <span class="nav-label">Remote</span>
                </div>
                <DesktopRemote :open="remoteOpen" @close="remoteOpen = false" />
            </div>

            <div class="search-wrapper" ref="searchWrapper">

                <div class="nav-item search" v-ripple @click="toggleSearch"
                    :class="{ active: searchOpen }">
                    <div class="nav-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" v-if="!searchOpen">
                            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
                            <path d="M16 16L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" v-else> <path d="M9.17218 14.8284L12.0006 12M14.829 9.17157L12.0006 12M12.0006 12L9.17218 9.17157M12.0006 12L14.829 14.8284" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    </div>
                </div>
                <transition name="search-expand">
                    <input
                        v-if="searchOpen"
                        ref="searchInput"
                        v-model="searchQuery"
                        type="text"
                        class="search-input"
                        placeholder="Search..."
                        @input="onSearchInput"
                        @keydown.esc="closeSearch"
                    />
                </transition>

            </div>
        </div>
    </nav>
</template>

<script>
const DesktopRemote = () => import('@/components/desktop/DesktopRemote')

export default {
    name: 'DesktopNav',

    components: {
        DesktopRemote,
    },

    data() {
        return {
            remoteOpen: false,
            searchOpen: false,
            searchQuery: '',
            scrolled: false,
            sections: [
                {
                    label: 'Home',
                    url: '/',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M3 12.1L12 3L21 12.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 10.5V19C5 19.5523 5.44772 20 6 20H10V15H14V20H18C18.5523 20 19 19.5523 19 19V10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                },
                {
                    label: 'Live',
                    url: '/live',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/><path d="M12 2C7.02944 2 2.72532 5.11417 1 9.5L3.07 10.5C4.48927 7.03449 7.96613 4.5 12 4.5C16.0339 4.5 19.5107 7.03449 20.93 10.5L23 9.5C21.2747 5.11417 16.9706 2 12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 7C9.23858 7 6.73858 8.34315 5 10.5L7.07 11.5C8.38268 9.95907 10.0873 9 12 9C13.9127 9 15.6173 9.95907 16.93 11.5L19 10.5C17.2614 8.34315 14.7614 7 12 7Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                },
                {
                    label: 'Games',
                    url: '/games',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><rect x="2" y="5" width="20" height="14" rx="5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M9 10L9 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 12H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="17" cy="10" r="1" fill="currentColor"/><circle cx="15" cy="14" r="1" fill="currentColor"/></svg>`,
                },
                {
                    label: 'Devices',
                    url: '/devices',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M2 9.4V2.6C2 2.26863 2.26863 2 2.6 2H21.4C21.7314 2 22 2.26863 22 2.6V9.4C22 9.73137 21.7314 10 21.4 10H2.6C2.26863 10 2 9.73137 2 9.4Z" stroke="currentColor" stroke-width="1.5"/><path d="M2 21.4V14.6C2 14.2686 2.26863 14 2.6 14H21.4C21.7314 14 22 14.2686 22 14.6V21.4C22 21.7314 21.7314 22 21.4 22H2.6C2.26863 22 2 21.7314 2 21.4Z" stroke="currentColor" stroke-width="1.5"/></svg>`,
                },
            ],
        }
    },

    watch: {
        $route(){
            if (this.$route.path.includes('search')){return}
            this.searchOpen = false
        }
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside)
        window.addEventListener('scroll', this.handleScroll, { passive: true })
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
        window.removeEventListener('scroll', this.handleScroll)
    },

    methods: {
        isActive(url) {
            return this.$route.path === url || this.$route.path.startsWith(url + '/')
        },

        goTo(url) {
            if (this.$route.path !== url) {
                this.$router.push(url)
            }
        },

        toggleRemote() {
            this.remoteOpen = !this.remoteOpen
        },

        toggleSearch() {
            this.$router.push('/search')
            this.searchOpen = !this.searchOpen

            if (this.searchOpen) {
                this.$nextTick(() => {
                    this.$refs.searchInput && this.$refs.searchInput.focus()
                    if(this.searchQuery){
                        this.onSearchInput()
                    }
                })
            } else {
                this.closeSearch()
            }
        },

        closeSearch() {
            this.searchOpen = false
            this.$router.back()
            //this.searchQuery = ''
            //this.$root.$emit('desktopSearch', '')
        },

        onSearchInput() {
            this.$root.$emit('desktopSearch', this.searchQuery)
        },

        handleClickOutside(e) {
            if (this.remoteOpen && this.$refs.remoteWrapper && !this.$refs.remoteWrapper.contains(e.target)) {
                this.remoteOpen = false
            }
        },

        handleScroll() {
            this.scrolled = window.scrollY > 0
        },
    },
}
</script>

<style lang="scss" scoped>
.desktop-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    //backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1000;
    padding: 0 48px;
    transition: background-color 0.2s ease;

    &.scrolled {
        background-color: rgba(20, 20, 20, 0.95);
        backdrop-filter: blur(20px);
    }
}

.nav-left {
    display: flex;
    align-items: center;
    gap: 32px;

    .brand {
        cursor: pointer;

        h2 {
            margin: 0;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 2px;
            color: white;
        }
    }
}

.nav-items {
    display: flex;
    align-items: center;
    gap: 4px;
}

.nav-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    border-radius: 8px;
    cursor: pointer;
    color: white;
    transition: all 0.15s ease;

    &:hover {
        color: white;
        background-color: rgba(255, 255, 255, 0.08);
    }

    &.active {
        color: white;
        background-color: rgba(255, 255, 255, 0.12);
        &.search{

        background-color: transparent;
        }
    }

    .nav-icon {
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            width: 18px;
            height: 18px;
        }
    }

    .nav-label {
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
    }
}

.nav-right {
    display: flex;
    align-items: center;
    gap: 8px;

    .remote-wrapper {
        position: relative;
    }

    .search-wrapper {
        display: flex;
        align-items: center;
    }

    .search-input {
        width: 200px;
        margin-right: 8px;
        padding: 7px 0px;
        border-radius: 0px;
        border: none;
        border-bottom: 1px solid white;
        background-color: transparent;
        color: white;
        font-size: 13px;
        outline: none;
        transition: width 0.2s ease, opacity 0.2s ease;

        &::placeholder {
            color: rgba(255, 255, 255, 0.4);
        }

        &.search-expand-enter-active,
        &.search-expand-leave-active {
            transition: width 0.2s ease, opacity 0.2s ease, margin-right 0.2s ease;
        }

        &.search-expand-enter,
        &.search-expand-leave-to {
            width: 0;
            opacity: 0;
            margin-right: 0;
            padding-left: 0;
            padding-right: 0;
            border-width: 0;
        }
    }
}
</style>
